// 表格显示每页数据条数
const pageDataCount = Object.freeze([20, 50, 100, 200])


// 获取表格每页数据条数
export function GetPageDataCount() {
  return pageDataCount
}

export const pickerOptions = {
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const start = new Date()
        const end = new Date(start.getTime() - 3600 * 1000 * 24 * 1)
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const start = new Date()
        const end = new Date(start.getTime() - 3600 * 1000 * 24 * 1)
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近三个月',
      onClick(picker) {
        const start = new Date()
        const end = new Date(start.getTime() - 3600 * 1000 * 24 * 1)
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
        picker.$emit('pick', [start, end])
      }
    }
  ],
  disabledDate(date) {
    return date.getTime() > Date.now() // 禁用大于今天的日期
  }
}

//1行内容の高さ
export const DIALOG_LINE_HEIGHT = 45;

/**工場区分 */
//大連
export const FACTORY_KBN_DALIAN = "1";
//日本
export const FACTORY_KBN_JAPAN = "2";
//本社
export const FACTORY_KBN_CPY = "3";

//本社
export const QUPTE_TYPE_CHANGE = "3";

//大連
export const STR_DALIAN = "大連";
//日本
export const STR_JAPAN = "日本";
//本社
export const STR_CPY = "本社";

// ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓
// 認証済みデバイス
export const RESULT_TD = "TD";
// 未承認デバイス
export const RESULT_UD = "UD";
// ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑

export const contractionList = { key: 'value' };

export const FINAL_STR = {

  // 入荷状態_検収済み
  "RECE_STATUS_END": "3",

  // 入荷状態_検収済み
  "RECE_STATUS_NEW": "1",

  // 未運送
  "TRD_TRANS_STATUS_NO_TRANS":"0",

  // 未運送
  "TRANS_STATUS_NO_TRANS": "1",

  // 未運送
  "TRANS_STATUS_NO_TRANS_STR": "未運送",

  // 担当者Id
  "USER_ID": "userId",

  // 通常製品
  "PROD_EX_GENERAL_STR": "-",

  // 通常製品
  "PROD_EX_GENERAL" : "1",

  // 外観検査
  "CRD_APPEARANCE_CHECK": "crdAppearanceCheck",

  //支払状態:  1:未支払
  "PAY_STATUS_NO_PAY": "1",

  //文字列 => 0
  "STR_ZERO": "0",
  //文字列 => 1
  "STR_ONE":"1",

  //クローズ状態: 0：未クローズ
  "CLOSE_STATUS_NO_CLOSE": 0,

  // 備考
  "CRD_REMARKS": "crdRemarks",

  // 請求済み
  "REQUEST_STATUS_END": "3",

}

//空白文字列
export const STR_EMPTY = "";
// ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
// 下線文字列
export const STR_UNDERLINE = "_";
// ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑

export const STR_ZERO = "0";
export const STR_ONE = "1";
export const STR_TWO = "2";
export const STR_THREE = "3";
// ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
// 課題_納期調整機能の追加
export const STR_FOUR = "4";
export const STR_FIVE = "5";
// ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
// ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
// 課題_発送予定機能の追加
export const STR_NINE = "9";
// ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

export const STR_TWELVE = "12";

export const STR_ZERO_ONE = "01";


export const STR_COLON = ":";
export const STR_BACKSLASH = "/";
export const STR_HYPHEN = "-";

// ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
export const STR_PERCENT = "%";
// ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑

//採番情報の受注状態 2:受注済み
export const NB_ORDER_STATE_ORDERED = "2";
//採番情報の受注状態 1:受注しない
export const NB_ORDER_STATE_NOT_ORDERED = "1";
//採番基本情報のプロセス区分 1：プロセス有
export const NB_PROC_KBN_TRUE = "1";
//採番基本情報のプロセス区分 0：プロセス無
export const NB_PROC_KBN_FALSE = "0";
//採番基本情報のプロセス区分 その他
export const NB_PROC_KBN_ELSE = "00";

//見積依頼のプロセス選択区分 1：選択しない
export const QR_PROC_KBN_FLAG_NOT_SELECTED = "1";
//見積依頼のプロセス選択区分 2：選択した
export const QR_PROC_KBN_FLAG_SELECTED = "2";

//受注情報の注文状態 2:注文済み
export const AOB_ORDER_STATUS_ORDERED = "2";
export const STR_AOB_ORDER_STATUS_ORDERED = "手配";//"注文済み";
//受注情報の注文状態 1:未注文
export const STR_AOB_ORDER_STATUS_NOT_ORDERED = "未手配";//"未注文";
//受注情報の受注状態 2:受注済み
export const AOB_ACCEPT_STATE_ACCEPT_ORDERED = "2";
export const STR_AOB_ACCEPT_STATE_ACCEPT_ORDERED = "受注済み";
//受注情報の受注状態 1:未受注
export const AOB_ACCEPT_STATE_NOT_ACCEPT_ORDERED = "1";
export const STR_AOB_ACCEPT_STATE_NOT_ACCEPT_ORDERED = "未受注";

//日本入荷工場: 大連
export const STR_FACTORY_DL = "大連";


//数字
export const NUM_ZERO = 0;
export const NUM_ONE = 1;
export const NUM_TWO = 2;

//正常製品の表示値
export const NORMAL_PROD = "-";

//コネクタ
export const CONNECTOR_SHORT_LINE = "-";

//状態:新規
export const STATUS_NEW = "新規";

//納品異常
export const PROD_EX_SEND = "納品異常 ";

//入荷異常
export const PROD_EX_JP_RCV = "入荷異常";

//支払予定
export const STR_PAY_PLAN = "支払予定";


//(受注データ取込) 1:受注待ち
export const DIB_ACCEPT_ORDER_WAITING = "1";
//(受注データ取込) 受注待ち
export const STR_DIB_ACCEPT_ORDER_WAITING = "受注待ち";
//(受注データ取込) 受注済み
export const STR_DIB_ACCEPT_ORDER_END = "受注済み";
//(受注データ取込) 製品
export const STR_DID_TYPE_PRODUCT = "製品";

//部門: 7 品質保証部
export const STR_DEPARTMENT_SEVEN = "7";

//緊急度: 0 -
export const STR_URGENT_ZERO = "0";
//緊急度: 1 必須
export const STR_URGENT_ONE = "1";


// ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
// 課題_納期分割機能の追加
export const STR_NOT_RCV = "未入荷";
export const STR_PART_RCV = "部分入荷";
export const STR_RCV_OVER = "入荷済み";

// 連結の異常区分表示
export const PROD_GENERAL_JP_EX = "正常→異常";
export const PROD_SEND_JP_EX = "納品→異常";

// ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑


// ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
export const STR_MISUMI = "ミスミ";

export const STR_SUPPLEMENTAL = "金額調整";
// ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

// ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
// ミスミ_大連
export const MSM_DL_KBN = "5";
// ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

// ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
// 一式機能の追加
export const UNIT_SET = "式";
// ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
